import React from 'react';
import { SimpleBlock } from 'ui-builder';
import { PDFViewer } from 'features/nekst-widgets';

import styles from '../FromContract/ValidateData/ValidateData.module.scss';

export default function VerifyDataLayout(props: {
  roadmap: React.ReactNode;
  nextButton: React.ReactNode;
  detailFieldsList: React.ReactNode;
  fileLink?: string;
  children?: React.ReactNode;
}) {
  return (
    <>
      {props.roadmap}
      <SimpleBlock style={{ marginBottom: '4rem', overflow: 'hidden' }}>
        {props.nextButton}
      </SimpleBlock>
      <SimpleBlock className={styles.verifyBlock}>
        <SimpleBlock className={styles.boxesBlock}>
          {props.detailFieldsList}
        </SimpleBlock>
        <SimpleBlock className={styles.previewBlock}>
          {props.fileLink && <PDFViewer pdfUrl={props.fileLink} fileName="Contract" />}
        </SimpleBlock>
        {props.children}
      </SimpleBlock>
    </>
  );
}
